(function ($) {
  const SECTION_SELECTOR = '.it-detailed-process';
  const TITLE_SELECTOR = '.detailed-process__title';
  const ITEM_SELECTOR = '.detailed-process__item';
  const TOGGLE_SELECTOR = '.detailed-process__item-header';
  const PANEL_SELECTOR = '.detailed-process__panel';
  const TYPE_SPEED = 85;

  function prepareTypedSpan(section) {
    const title = section.querySelector(TITLE_SELECTOR);

    if (!title) {
      return null;
    }

    const span = title.querySelector('span');

    if (!span) {
      return null;
    }

    const source = span.textContent || '';

    if (!source) {
      return null;
    }

    span.dataset.typedSource = source;
    span.innerHTML = '';

    return span;
  }

  function typeSpan(span) {
    if (!span || span.dataset.typedStarted === 'true') {
      return;
    }

    const source = span.dataset.typedSource || '';

    if (!source) {
      return;
    }

    span.dataset.typedStarted = 'true';

    let charIndex = 0;

    function tick() {
      charIndex += 1;
      span.textContent = source.slice(0, charIndex);

      if (charIndex < source.length) {
        window.setTimeout(tick, TYPE_SPEED);
      }
    }

    tick();
  }

  function initReveal(section) {
    const fadeElements = section.querySelectorAll('.fade-up');
    const typedSpan = prepareTypedSpan(section);

    if (!fadeElements.length) {
      return;
    }

    section.classList.add('is-reveal-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (typedSpan && entry.target.matches(TITLE_SELECTOR)) {
          window.setTimeout(() => {
            typeSpan(typedSpan);
          }, 180);
        }

        window.setTimeout(() => {
          entry.target.style.transitionDelay = '0ms';
        }, 850);

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px',
    });

    fadeElements.forEach((element, index) => {
      element.style.transitionDelay = `${index * 110}ms`;
      observer.observe(element);
    });
  }

  function initAccordion(section) {
    const $section = $(section);

    $section.find(ITEM_SELECTOR).each(function () {
      const $item = $(this);
      const $toggle = $item.find(TOGGLE_SELECTOR).first();
      const $panel = $item.find(PANEL_SELECTOR).first();

      if (!$toggle.length || !$panel.length) {
        return;
      }

      $panel.toggle($item.hasClass('is-open'));

      $toggle.on('click', function () {
        const isOpen = $item.hasClass('is-open');

        if (isOpen) {
          $item.removeClass('is-open');
          $toggle.attr('aria-expanded', 'false');
          $panel.stop(true, true).slideUp(420);
          return;
        }

        $item.addClass('is-open');
        $toggle.attr('aria-expanded', 'true');
        $panel.stop(true, true).slideDown(420);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initReveal(section);
      initAccordion(section);
    });
  });
})(jQuery);
